<Caption :title="$route.meta.title"></Caption><ClassmatesList teachers="true"></ClassmatesList>